import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "./styles/BitacoraFletes.css";

export default class BitacoraFletes extends Component {
    render() {
        const { match, history } = this.props;

        return (
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="BITÁCORA DE FLETES"
                    subtitulo="Cambios en los precios de flete de la finca"
                    noBorder
                >
                    <Listado
                        fincaId={match.params.id}
                        regresar={() => history.goBack()}
                    />
                </Card>
            </div>
        );
    }
}
